import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";

export class FiltroCoSeguimientoPedido {

    numerodoc: string;   
    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
    }
    paginacion: ParametroPaginacionGenerico;
}
